import { generateSkinDefaults } from '@wix/editor-elements-panel';
import type { SkinDefinition } from '@wix/editor-elements-panel/src/adapters/types';

// At the moment we need to keep this in sync with packages/editor-elements-design-panel-params/src/designPanelsConfigs/params.json
export const ColumnSkinDefinitionMap: Record<string, SkinDefinition> = {
  'wysiwyg.viewer.skins.column.DesignedColumn': {
    brw: {
      type: 'BORDER_SIZES',
      defaultValue: '0px',
      state: 'regular',
    },
    brd: {
      type: 'BORDER_COLOR_ALPHA',
      defaultValue: 'color_16',
      state: 'regular',
    },
    rd: {
      type: 'BORDER_RADIUS',
      defaultValue: '0px',
      state: 'regular',
    },
    shd: {
      type: 'BOX_SHADOW',
      defaultValue: '0 0 0 rgba(0, 0, 0, 0)',
      state: 'regular',
    },
  },
};

export default generateSkinDefaults(ColumnSkinDefinitionMap);
